module.exports = "/images/bafc18e9d89dc00b3a95b9403a1492c7.svg";